import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-addmaterialdocuments',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './addmaterialdocuments.component.html',
  styleUrls: ['./addmaterialdocuments.component.scss'],
})
export class AddmaterialdocumentsComponent implements OnInit {
  display: any = 'none';
  displayDelete: any = 'none';
  category: any;
  subject: any;
  document: any;
  cources: any[];
  courseData: any;
  materialdata: any[];
  subjectdata: any[];
  showAdd = false;
  showEdit = false;
  id: any;

  courseForm: UntypedFormGroup;

  showErr = false;
  deleteErr: any;

  searchval: any;

  error_messages = {
    categorytypeval: [{ type: 'required', message: 'Please Select Category' }],
    Subjecttypeval: [{ type: 'required', message: 'Please Select Year' }],
    documentval: [{ type: 'required', message: 'Please enter Document Name' }],
  };
  adminName: any;
  adminImage: any;
  allCourse: any;
  allData: any;

  showData = false;
  showNodata = false;

  @ViewChild('boxCourse', { static: false }) boxCourse: ElementRef;
  docx_name: any;
  docx_file: any;
  materialdox: any;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.courseForm = this.formBuilder.group({
      categorytypeval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      Subjecttypeval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      documentval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;
    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  deletematerialcategorydocument(id) {
    this.spinner.show();
    let payload = {
      id: id,
    };
    const servicePath = this.utils.getApiConfigs('materialcatergorydocument');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.globalService.showSuccess('Document Delete Successfully');
          this.display = 'none';
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
        }
      });
  }

  ngOnInit(): void {
    this.spinner.show();
    this.getallmaterialdox();
    this.getmaterialcategory();
    this.spinner.show();
    this.courseForm.reset();
    // Get All Courses \\
  }

  onMouseOver(e) {
    (<HTMLDivElement>this.boxCourse.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxCourse.nativeElement).style.cursor = 'pointer';
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    // console.log("val", val);

    this.allData = this.courseData;

    // console.log("All Data", this.allData);

    if (val) {
      this.allCourse = this.allData.filter((item) =>
        item.courses.toLowerCase().includes(val.toLowerCase())
      );
    }

    // console.log("Courses Data", this.allCourse);
    if (this.allCourse == '') {
      this.globalService.showError('No data found');
    }
  }
  onChangecategory(event) {
    console.log('==================', this.category);
    this.getmaterialsubject();
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  addCourse() {
    this.spinner.show();
    let formData: FormData = new FormData();
    //  console.log(this.subject)
    formData.append('material_sub_id', this.subject);
    formData.append('docx_name', this.document);
    formData.append('docx', this.docx_file, this.docx_name);

    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('materialdocx');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, formData)
      .then((resp: any) => {
        console.log('resp', resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess(
            'Material Document  added Successfully'
          );
          this.display = 'none';
          this.ngOnInit();
          this.courseForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          this.display = 'none';
          // console.log("data", resp.data);
        }
      });
  }
  onFileSelected(event) {
    if (event.target.files.length > 0) {
      this.docx_file = event.target.files[0];
      this.docx_name = event.target.files[0].name;
      console.log(event.target.files[0].name);
    }
  }
  openAdd() {
    this.courseForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  // editCourse(data){
  //   // console.log("Data", data);
  //   this.display = "block";
  //   this.showAdd = false;
  //   this.showEdit = true;

  //   this.courseName = data.courses;
  //   this.id = data.id;
  // }

  deleteCourse(data) {
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
    this.spinner.show();
  }

  // updateCourse(){
  //   this.spinner.show();
  //   let payload = {
  //     "courses": this.courseName,
  //     "id": this.id
  //   }
  //   // console.log("payload", payload);
  //   const servicePath = this.utils.getApiConfigs('course');
  //   this.commonservice.invokeService(servicePath[0].method, servicePath[0].path, payload)
  //     .then((resp: any) => {
  //       // console.log("resp", resp);
  //       this.spinner.hide();
  //       if (resp.status_code == "200") {
  //         this.spinner.hide();
  //         // console.log(resp);
  //         this.globalService.showSuccess("Course updated successfully");
  //         this.display = "none";
  //         this.ngOnInit();
  //         this.courseForm.reset();
  //       }else if(resp.status_code == "400"){
  //         this.spinner.hide();
  //         // console.log("data", resp.data);
  //         this.globalService.showError(resp.data);
  //         this.display = "none";
  //       }
  //     });
  // }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
    this.spinner.show();
  }

  getmaterialcategory() {
    this.spinner.show();

    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('getcategory');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, '')
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.materialdata = resp.data;
          console.log('----------------------', this.materialdata);
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  getallmaterialdox() {
    this.spinner.show();

    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('allmaterialdocx');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, '')
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.materialdox = resp.data;
          console.log('----------------------doc', this.materialdox);
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  getmaterialsubject() {
    this.spinner.show();
    var payload = {
      material_cat_id: this.category,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('materialonlysubject');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.subjectdata = resp.data;
          console.log('----------------------', this.subjectdata);
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletecourses');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Course deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.showErr = true;
          this.deleteErr = resp.message;
        }
      });
  }
}
